module.exports = __webpack_public_path__ + "static/media/015.281fb14f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/thumbs/015.jpg
// module id = 522
// module chunks = 0